import React, { memo } from 'react';
import Col from '../Utils/Col/Col';
import ArticleCard from '../ArticleCard/ArticleCard';
import { StoryblokNode } from '../../interfaces/StoryblokNode.interface';
import { StoryblokArticle } from '../../interfaces/StoryblokArticle.interface';
import Grid from '../Utils/Grid/Grid';
import { HeadingTypes } from '../Heading/Heading';
import { v4 as uuidv4 } from 'uuid';

interface ArticleCardsProps {
  articles_to_show: StoryblokNode<StoryblokArticle>[];
  articleCardHeadingType: HeadingTypes;
  articleCardHeadingStyleType: HeadingTypes;
}

const ArticleCards: React.FC<ArticleCardsProps> = ({
  articles_to_show,
  articleCardHeadingType,
  articleCardHeadingStyleType,
}) => {
  return (
    <Grid gapY="gap-y-6" gapX="gap-x-6">
      {articles_to_show.map(
        (article_to_show: StoryblokNode<StoryblokArticle>) => (
          <Col
            key={uuidv4()}
            span={{ md: articles_to_show.length === 3 ? 4 : 6 }}
          >
            <ArticleCard
              article={article_to_show}
              headingType={articleCardHeadingType}
              headingStyleType={articleCardHeadingStyleType}
            />
          </Col>
        )
      )}
    </Grid>
  );
};

export default memo(ArticleCards);
